import React, { useState, useEffect } from "react";

import Bitlink from "../Links/Bitlink";
import Yourl from "../Links/Yourl";

import { loadYourls } from "../../services/Yourls";
import { loadBitlinksByGroup } from "../../services/Bitly";

import { removeAllParamsURL } from "../../services/helpers";

const ListLinks = () => {
	
	const [state, updateState] = useState({
		access_token: process.env.REACT_APP_ACCESS_TOKEN,
		showBitly: true,
		showYourls: true,
		linksBitly: [],
		linksYourls: [],
		loadedBitlyLinks: false,
		loadedYourlsLinks: false,
		search: ""
	});

	const handleChangeSearch = event => {
		updateState({ ...state, search: event.target.value });
	};

	const filterLinks = (searchItem, linksCollection) => {
		const links = linksCollection.filter(link => {
			const linkHasTitle = !!link.title;
			if (!linkHasTitle) {
				return false;
			}

			const searchMatchesTitle = link.title
				.toLowerCase()
				.includes(searchItem.toLowerCase());

			const _url = link.long_url ? link.long_url : link.url;
			const searchMatchesUrl =  removeAllParamsURL(_url).includes(
				searchItem.toLowerCase()
			);

			return searchMatchesTitle || searchMatchesUrl;
		});
		
		return links;
	}
	
	const Bitlinks = () => {
		const searchItem = state.search;
		let Links;

		if(!searchItem) {
			Links = state.linksBitly;
		}
		else {
			Links = filterLinks(searchItem, state.linksBitly);
		}

		return Links && Links.length > 0 && Links.map((link, index) => <Bitlink key={index} link={link} />);
	};

	const Yourls = () => {
		const searchItem = state.search;
		let Links;

		if (!searchItem) {
			Links = state.linksYourls;
		}
		else {
			Links = filterLinks(searchItem, state.linksYourls);
		}
		
		return Links && Links.length > 0 && Links.map((link, index) => <Yourl key={index} link={link} clicks={link.clicks} />);
	};

	useEffect(() => {
		if (!state.loadedYourlsLinks) {
			loadYourls((result, response) => {
				updateState({ ...state, linksYourls: result.links, loadedYourlsLinks: true });
			})
		}

		if (!state.loadedBitlyLinks) {
			loadBitlinksByGroup(state).then( (data) => {
				updateState({ ...state, linksBitly: data.data.links, loadedBitlyLinks: true });
			});
		}
	}, [state]);

	return (
		<>
			<div className='container-fluid'>
				<div className='pesquisa'>
					<input
						className='form-control'
						type='text'
						placeholder='Pesquisar'
						value={state.search}
						onChange={handleChangeSearch}></input>
				</div>

				<ul className='lista-links'>
					<Yourls />
					<Bitlinks />
				</ul>
			</div>
		</>
	);
};

export default ListLinks;
